/* FreshBox mega-nav — image+caption swap per subcategory, reset to golden hero on leave.
   Mirrors the prototype behaviour. Pure progressive enhancement (CSS handles reveal). */
(function () {
  /* Las fotos del panel (previews + héroe dorado) viajan en data-bg, no en style=, para
     que el navegador NO las baje al cargar la página: eran ~50 imágenes / ~3.5 MB de
     paneles ocultos que competían con el hero y con el propio HTML. Se asignan la primera
     vez que el cursor o el foco entra al ítem; el resto del swap sigue siendo el de siempre.
     Al entrar solo se pide la foto visible (el héroe); la de cada subcategoría se pide
     cuando el cursor llega a ella, así un hover baja 1 foto en vez de las ~12 del panel. */
  function pinta(el) {
    if (el.dataset.bgOk) return;
    el.dataset.bgOk = '1';
    el.style.backgroundImage = "url('" + el.getAttribute('data-bg') + "')";
  }
  // Pide la foto y avisa cuando ya está lista (o a los 350 ms como tope), para que el
  // fundido no arranque sobre un fondo vacío.
  function precarga(el, cb) {
    if (!el || !el.hasAttribute('data-bg') || el.dataset.bgOk) { cb(); return; }
    var hecho = false;
    function listo() { if (hecho) return; hecho = true; pinta(el); cb(); }
    var im = new Image();
    im.onload = im.onerror = listo;
    im.src = el.getAttribute('data-bg');
    setTimeout(listo, 350);
  }
  function cargaFondos(item) {
    if (item.dataset.bgDone) return;
    item.dataset.bgDone = '1';
    item.querySelectorAll('[data-bg]').forEach(function (el) {
      if (!el.classList.contains('fbprev__img') || el.classList.contains('is-active')) pinta(el);
    });
  }
  document.querySelectorAll('.fbnav__item').forEach(function (item) {
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
      item.addEventListener(ev, function () { cargaFondos(item); }, { passive: true });
    });
    // Si el cursor ya estaba encima cuando corrió este guion (va con defer), no hubo enter.
    try { if (item.matches(':hover')) cargaFondos(item); } catch (e) {}
  });

  document.querySelectorAll('.fbnav__item').forEach(function (item) {
    var prev = item.querySelector('[data-prev]');
    if (!prev) return;
    var imgs = prev.querySelectorAll('.fbprev__img');
    var cap = prev.querySelector('[data-cap]');
    var k = cap ? cap.querySelector('.kick') : null;
    var t = cap ? cap.querySelector('.t') : null;
    var d = cap ? cap.querySelector('.d') : null;
    // El botón del panel también sigue al elemento sobre el que estás: si la
    // foto y el texto cambian y el botón no, "Explorar" lleva a otro lado.
    var cta = prev.querySelector('.fbprev__cta');

    // snapshot the default (golden hero) state once
    var def = prev.querySelector('.fbprev__img.is-active') || imgs[0];
    var dk = k ? k.innerHTML : '';
    var dt = t ? t.innerHTML : '';
    var dd = d ? d.innerHTML : '';
    var dh = cta ? cta.getAttribute('href') : null;

    var turno = 0; // descarta swaps cuya foto llegó tarde (el cursor ya se movió)
    function reset() {
      turno++;
      imgs.forEach(function (im) { im.classList.toggle('is-active', im === def); });
      if (k) k.innerHTML = dk;
      if (t) t.innerHTML = dt;
      if (d) d.innerHTML = dd;
      if (cta && dh) cta.setAttribute('href', dh);
    }

    item.querySelectorAll('.fbsub a').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        var key = link.getAttribute('data-img');
        var mio = ++turno;
        var dest = prev.querySelector('.fbprev__img[data-img-' + key + ']');
        precarga(dest, function () {
          if (mio !== turno) return;
          imgs.forEach(function (im) { im.classList.toggle('is-active', im.hasAttribute('data-img-' + key)); });
          if (k) k.textContent = link.getAttribute('data-kick') || '';
          if (t) t.textContent = link.getAttribute('data-title') || '';
          if (d) d.textContent = link.getAttribute('data-desc') || '';
          if (cta) cta.setAttribute('href', link.getAttribute('href') || dh);
        });
      });
    });

    item.addEventListener('mouseleave', reset);
  });
})();
